<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2021-07-26 09:51:01
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-06 11:21:58
-->
<template>
  <div id="root">
    <div class="root">
      <!-- <div class="title">
        <span>友情链接</span>
      </div> -->
      <div class="content">
        <!-- <a href="http://www.henan.gov.cn/" target="_blank"><img src="../../../assets/img/河南省人民政府.png" alt=""></a>
                                                                                                                                                                      <a href="http://www.puyang.gov.cn/" target="_blank"><img src="../../../assets/img/市人民政府.png" alt=""></a>
                                                                                                                                                                      <a href="http://www.hnls.gov.cn/" target="_blank"><img src="../../../assets/img/县人民政府.png" alt=""></a> -->
        <a style="width: 310px" target="_blank" href="http://www.moa.gov.cn/"
          ><span>中华人民共和国农业农村部</span></a
        >|
        <a target="_blank" href="https://www.henan.gov.cn/"
          ><span>河南省人民政府</span></a
        >|
        <a target="_blank" href="https://nynct.henan.gov.cn/"
          ><span>河南省农业农村厅</span></a
        >|
        <a target="_blank" href="http://www.puyang.gov.cn/"
          ><span>{{ cityDetail.cityName }}人民政府</span></a
        >|
        <!-- <a target="_blank" href="http://www.hnls.gov.cn/"><span>{{cityDetail.cityName}}人民政府</span></a>| -->
        <a target="_blank" href="http://nyncj.puyang.gov.cn/pc/"
          ><span>{{ cityDetail.cityName }}农业农村局</span></a
        >
      </div>
      <!-- <div class="foot1">
        <div class="foot1-l">
          <div class="title1">{{ dataList[0].classname }}</div>
          <div v-for="item in dataList[0].list" :key="item.id" class="subtit"
            @click="toDetail(dataList[0].classname, item)"><span class="dian">.</span>{{ item.title }}</div>

        </div>
        <div class="foot1-c">
          <img src="../../../assets/img/erweima.png" alt="" style="width:200px;height:200px">
        </div>
        <div class="foot1-r">
          <div class="title1">{{ dataList[1].classname }}</div>
          <div v-for="item in dataList[1].list" :key="item.id" class="subtit"
            @click="toDetail(dataList[1].classname, item)"><span class="dian">.</span>{{ item.title }}</div>
        </div>
      </div>
      <div class="footer">
        <div>
          <span style="opacity: 0.8;font-size: 24px;">主办单位：</span>
          <span style="opacity: 1;font-size: 24px;">{{cityDetail.cityName}}农业农村局</span>
        </div>
        <div>
          <span style="opacity: 0.8;font-size: 24px;">联系电话：</span>
          <span style="opacity: 1;font-size: 24px;">0393-8154616</span>
        </div>
        <div>
          <span style="opacity: 0.8;font-size: 24px;">技术支持：</span>
          <span style="opacity: 1;font-size: 24px;">河南晟宇信息技术有限公司</span>
        </div>
        <div>
          <span style="opacity: 0.8;font-size: 24px;">联系电话：</span>
          <span style="opacity: 1;font-size: 24px;">0371-55088517</span>
        </div>
      </div> -->
      <div style="display: flex">
        <div
          style="
            flex: 1;
            text-align: center;
            display: flex;
            flex-direction: column;
          "
        >
          <div style="flex: 1">
            <div class="foot1-l">
              <div class="title1">
                {{ dataList[0] ? dataList[0].classname : "" }}
              </div>
              <div
                v-for="item in dataList[0] ? dataList[0].list : 0"
                :key="item.id"
                class="subtit"
                @click="
                  toDetail(dataList[0] ? dataList[0].classname : '', item)
                "
              >
                <span class="dian">.</span>{{ item.title }}
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              height: 50px;
              justify-content: center;
              flex: 1;
            "
          >
            <div style="margin-right: 15px">
              <span style="opacity: 0.8; font-size: 24px">主办单位：</span>
              <span style="opacity: 1; font-size: 24px"
                >{{ cityDetail.cityName }}农业农村局</span
              >
            </div>
            <div>
              <span style="opacity: 0.8; font-size: 24px">联系电话：</span>
              <span style="opacity: 1; font-size: 24px">0393-8154616</span>
            </div>
          </div>
        </div>
        <div>
          <img
            src="../../../assets/img/erweima.png"
            alt=""
            style="width: 200px; height: 200px"
          />
        </div>
        <div style="flex: 1; display: flex; flex-direction: column">
          <div style="flex: 1; box-sizing: border-box; height: 50%">
            <div class="foot1-r">
              <div class="title1">
                {{ dataList[1] ? dataList[1].classname : "" }}
              </div>
              <div
                v-for="item in dataList[1] ? dataList[1].list : ''"
                :key="item.id"
                class="subtit"
                @click="
                  toDetail(dataList[1] ? dataList[1].classname : '', item)
                "
              >
                <span class="dian">.</span>{{ item.title }}
              </div>
            </div>
          </div>
          <div
            style="display: flex; justify-content: center; flex: 1; height: 50%"
          >
            <div style="margin-right: 15px">
              <span style="opacity: 0.8; font-size: 24px">技术支持：</span>
              <span style="opacity: 1; font-size: 24px"
                >河南晟宇信息技术有限公司</span
              >
            </div>
            <div>
              <span style="opacity: 0.8; font-size: 24px">联系电话：</span>
              <span style="opacity: 1; font-size: 24px">0371-55088517</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { help } from '../../../api/mian.js'

export default {
  data () {
    return {
      dataList: [{}, {}],
    }
  },
  created () {
    help().then((res) => {
      this.dataList = res.data.data
    })
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    toDetail (classname, item) {
      this.$router.push({
        name: '帮助中心详情',
        query: { classname, item: JSON.stringify(item) },
      })
    },
  },
}
</script>

<style scoped>
span {
  /* color: ; */
}

#root {
  /* width: 2360px;
  background: url("../../../assets/img/footer.png") no-repeat;
  background-size: 100%; */
  width: 100%;
  margin: 0 auto;
  /* height: 400px; */
  /* background: url("../../../assets/img/footer.png") no-repeat; */
  background-color: #fff;
  /* color: white; */
  background-size: 100% 100%;
}

.root {
  width: 1864px;
  /* height: 300px; */
  /* background: #ffffff; */
  /* box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1); */
  overflow: hidden;
  margin: 0 auto;
}

.title {
  padding: 0 37px;
  width: 100%;
  height: 90px;
  border-bottom: 1px solid #2187ff;
  /* background-color: pink; */
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  line-height: 80px;
}

.title > span {
  border-left: #2187ff 6px solid;
  padding: 0 5px;
  /* background-color: #fff; */
}

.content {
  padding: 23px 15px;
  width: 100%;
  height: auto;
  overflow: hidden;
  font-size: 24px;
  padding-bottom: 0;
  margin-bottom: 30px;
  text-align: center;
}

.content > a {
  display: inline-block;
  /* width: 210px; */
  height: auto;
  /* box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1); */
  margin: 0 20px;
  margin-bottom: 10px;
  margin: 0 40px;
  text-align: center;
}

.foot1 {
  /* border: 1px solid red; */
  display: flex;
  font-size: 24px;
  justify-content: space-around;
  text-align: center;
  padding: 0 180px;
}

.foot1-l {
  /* margin-left:80px; */
  /* width: 200px; */
  /* border: #6681EA 1px solid; */
  text-align: left;
  text-align: center;
}

.foot1-r {
  /* margin-left:100px; */
  /* width: 200px; */
  /* border: #6681EA 1px solid; */
  text-align: center;
}

.title1 {
  font-size: 34px;
  font-weight: 600;
  margin: 10px 0;
}

.subtit {
  text-align: center;
  cursor: pointer;
  opacity: 0.8;
  height: 45px;
  font-size: 28px;
}

.footer {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}

.dian {
  position: relative;
  /* border: #6681EA 1px solid; */
  margin: 10px;
  top: -8px;
  /* height: 45px;
  line-height: 45px; */
  font-size: 30px;
}
</style>
